import { timeDifMilliseconds } from '../../util/time_utils'
import { getDefaultTimespan, withinSpanChecker } from '../../util/date_utils'

export function sumTagDurations(timeEntries, span) {
    const {start, end} = span
    const spanChecker = withinSpanChecker(start, end)
    const tagDurationsMap = timeEntries.reduce(
        (acc, entry) => {
            if (spanChecker(new Date(entry.startAt))) {
                entry.tags.forEach( t => acc[t] = (acc[t] || 0) + entry.duration / 1000 )
            }
            return acc
        },
        {}
    )

    return Object.keys(tagDurationsMap)
        .map( k => ({tag: k, totalDuration: tagDurationsMap[k] }))
        .sort( (a,b) => b.totalDuration - a.totalDuration )
}

// Rollup fuctions
export function rollUpTimeEntries(timeEntries, interval = "Day", span, runningEntries = [], collapse = true) {
    const intervalBuckets = makeintervalBuckets(interval, span)
    // Time Entries bucketed by interval (Day)
    const bucketedByInterval = timeEntries.sort((a, b) => a.startAt - b.startAt).reduce((acc, c) => bucketByInterval(c, acc, interval), intervalBuckets)
    const postprocessRollup = rollup => {
        Object.keys(rollup).map(key => {
            const rollupDetail = rollup[key]
            const { latestEntry } = rollupDetail
            delete rollupDetail.latestEntry
            rollupDetail.latestEntryId = latestEntry.id
        })
        return rollup
    }
    // Rollups bucketed by day
    const rollups = Object.keys(bucketedByInterval).reduce((acc, key) => ({
        ...acc,
        [key]: postprocessRollup(bucketedByInterval[key].reduce((acc, c) => buildRollup(c, acc, runningEntries, collapse), {})),
    }), {})

    // Convert bucketed rollups to array
    const rollupsArr = Object.keys(rollups).sort().map(date => {
        return {
            date: new Date(+date).toISOString(),
            total: Object.values(rollups[date]).reduce((acc, c) => acc + c.total, 0),
            items: Object.values(rollups[date]),
        }
    })

    return rollupsArr
}

// Rollup fuctions
export function rollupTimeEntriesByUser(timeEntries, interval = "Day", span, runningEntries = [], collapse = true) {
    // bucket time entries by user (userId -> [array of time entries]
    const entriesBucketedByUser = timeEntries.reduce(
        (acc, entry) =>
            ({
                ...acc,
                [entry.userId]: [ ...(acc[entry.userId] || []), entry ],
            }),
        {})

    // convert map values from [array of time entries] -> rollups
    Object.keys(entriesBucketedByUser).forEach( k => {
        const userEntries = entriesBucketedByUser[k]
        entriesBucketedByUser[k] = {
            timeEntries: userEntries,
            rollups: rollUpTimeEntries(userEntries, interval, span, runningEntries, collapse),
        }
    })

    return entriesBucketedByUser
}

function makeintervalBuckets(interval, { start, end }) {
    let buckets = {}
    let date = getIntervalDate(interval, +end)
    while (withinSpanChecker(start, end)(+date)) {
        buckets[date] = []
        date = getIntervalDate(interval, +date - 1)
    }

    return buckets
}

function buildRollup(entry, obj, runningEntries, collapse) {
    // key off entry id if collapsed; otherwise its the tags
    const tagKey = collapse ? entry.tags.sort().join(',') : entry.id
    obj[tagKey] = mergeRollup(obj[tagKey], entry, runningEntries)
    return obj
}

function mergeRollup(rollup, entry, allRunningEntries) {
    if (!rollup) return entryToRollup(entry)
    // calculate new total duration
    const total = rollup.total + timeDifMilliseconds(entry)
    // add on any new descirptions, removing dupes
    const descriptions = rollup.descriptions.filter(d => d !== entry.description).concat(entry.description)

    const runningEntries = rollup.runningEntries
    if (!entry.endAt && allRunningEntries.indexOf(entry.id) > -1 && runningEntries.indexOf(entry.id) == -1) {
        runningEntries.push(entry.id)
    }
    return {
        ...rollup,
        total,
        descriptions,
        runningEntries: runningEntries,
        latestEntry: entry.startAt > rollup.latestEntry.startAt ? entry : rollup.latestEntry,
    }
}

function entryToRollup(entry) {
    const runningEntries = []
    if (!entry.endAt) {
        runningEntries.push(entry.id)
    }
    return {
        id: entry.id,
        tags: entry.tags,
        total: timeDifMilliseconds(entry),
        descriptions: [entry.description],
        runningEntries: runningEntries,
        latestEntry: entry,
    }
}

function bucketByInterval(entry, obj, interval) {
    const key = Object.keys(obj).find(date => {
        const { start, end } = getDefaultTimespan(interval, +date)
        return withinSpanChecker(start, end)(+entry.startAt)
    })

    obj[key].push(entry)

    return obj
}

function getIntervalDate(interval, date) {
    const span = getDefaultTimespan(interval, +date)
    return span.start + ""
}


// WEBPACK FOOTER //
// ./src/common/pages/dashboard.js